import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFeather2"><Path d="M20.2646 4.09766C20.0948 4.42193 19.934 4.74507 19.7734 5.06836C19.614 5.38932 19.4537 5.71313 19.29 6.02539C18.9638 6.64766 18.6061 7.26062 18.166 7.79688C17.4671 8.64853 16.5817 9.27326 15.3496 9.52441C16.0937 11.1122 15.8532 12.7853 14.9551 14.124C13.8682 15.7439 11.8452 16.8525 9.5293 16.8525C6.78355 16.8525 4.5 18.52 4.5 21.25H3V16.1025C3.00022 8.86409 8.88554 3.00014 16.1406 3H20.8398L20.2646 4.09766Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFeather2;
